//Move to ui-components package as needed
import React from 'react';
import classnames from 'classnames';
import '../styles/index.scss';
type InvoiceCardProps = {
  additionalClasses?: string[];
  key: string;
  children?: React.ReactNode;
};

const InvoiceCard = (props: InvoiceCardProps) => {
  const { children, additionalClasses, key } = props;

  return (
    <div className={classnames('invoice-card', additionalClasses)} key={key}>
      {children}
    </div>
  );
};

export default InvoiceCard;
